
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "t": "1608443053491",
    "class": "icon",
    "viewBox": "0 0 1024 1024",
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "p-id": "6158",
    "width": "200",
    "height": "200"
  },
  "children": [
    {
      "tag": "path",
      "attrsMap": {
        "d": "M695.872 49.344a44.416 44.416 0 0 0-9.728 1.088 45.184 45.184 0 0 0-23.936 8.704l-386.56 175.872-131.456-0.32v0.256h-45.952A92.16 92.16 0 0 0 6.336 326.72l0.32 373.632a91.968 91.968 0 0 0 91.52 88.448h46.592a46.08 46.08 0 0 0 4.544-91.84s-61.184 14.464-50.88-89.728l-0.064-198.848 0.256 10.56c0-69.696 13.696-89.216 75.904-91.84l108.224 0.192a45.632 45.632 0 0 0 19.776-4.672 43.2 43.2 0 0 0 11.456-5.888l335.936-152.832 0.32 696.064-296.064-140.16c-20.48-15.04-49.28-10.56-64.256 9.984s-10.56 49.472 9.984 64.512l362.304 171.584c9.472 6.976 20.736 9.6 31.616 8.512 0.832 0.064 1.6 0.256 2.496 0.256a46.08 46.08 0 0 0 45.952-46.144l-0.448-832.96a46.08 46.08 0 0 0-45.952-46.208z m-597.248 555.52c-0.128 0.896 0 1.472-0.064 2.368V608l0.064-3.136z m817.536-329.92a45.952 45.952 0 0 0-18.88-16.576c-6.72-5.44-20.416-4.544-20.416-4.544a46.08 46.08 0 0 0-45.248 46.08l0.448 4.288c0 25.088 44.8 66.112 44.8 66.112a230.08 230.08 0 0 1 0 280.064s-45.248 39.872-45.248 65.088l0.448 4.288c0 25.088 19.968 45.44 44.8 46.08 0 0 16 0.384 23.68-6.016a45.824 45.824 0 0 0 14.784-13.248 323.648 323.648 0 0 0 0.832-471.616z",
        "p-id": "6159"
      }
    }
  ]
})
    }
  